import { DataDisplayActions } from "@components/common/data-display-actions";
import { CreateProjectDialog } from "@pages/projects/create-project-dialog";

/** Returns the action buttons of the projects tab */
export function ProjectsTabActionButtons(): JSX.Element {
  return (
    <>
      <DataDisplayActions subjectType="project" />

      {/* Create new project button */}
      <CreateProjectDialog />
    </>
  );
}
